import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import logoImg from '../assets/logo.png';
import CountdownTimer from './CountdownTimer';

const lexend = '"Lexend", sans-serif';

export default function SiteHeader({ onWaitlistClick, ctaLabel = 'Join The Waitlist', showTimer = true }) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const closeMenu = () => setMenuOpen(false);

  const handleWaitlist = (e) => {
    e?.preventDefault?.();
    closeMenu();
    onWaitlistClick?.();
  };

  return (
    <header
      className="site-header"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        background: 'white',
        boxShadow: isScrolled ? '0 2px 10px rgba(0,0,0,0.1)' : 'none',
        transition: 'box-shadow 0.3s ease',
        zIndex: 1000,
        padding: '1rem 2rem',
      }}
    >
      <div className="site-header-inner" style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        maxWidth: '1400px',
        margin: '0 auto',
      }}>
        <Link to="/" onClick={closeMenu} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', textDecoration: 'none' }}>
          <img
            src={logoImg}
            alt="NearStay"
            className="site-header-logo"
            style={{ height: '60px', width: 'auto' }}
          />
          <span style={{
            fontFamily: lexend,
            fontOpticalSizing: 'auto',
            fontSize: '1.65rem',
            fontWeight: 700,
            color: '#1c3dfe',
          }}>
            NearStay
          </span>
        </Link>

        <nav className="site-nav-links" style={{ display: 'flex', alignItems: 'center', gap: '1.5rem' }}>
          {showTimer && <CountdownTimer compact label={null} />}
          <button
            onClick={handleWaitlist}
            style={{
              background: '#c038ff',
              color: 'white',
              border: 'none',
              padding: '0.6rem 1.5rem',
              borderRadius: '9999px',
              fontFamily: lexend,
              fontOpticalSizing: 'auto',
              fontSize: '1rem',
              fontWeight: 600,
              cursor: 'pointer',
              boxShadow: '0 4px 14px rgba(0, 200, 255, 0.9)',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              transition: 'opacity 0.2s ease',
            }}
            onMouseOver={(e) => { e.currentTarget.style.opacity = '0.9'; }}
            onMouseOut={(e) => { e.currentTarget.style.opacity = '1'; }}
          >
            {ctaLabel}
          </button>
        </nav>

        <button
          type="button"
          className={`site-nav-toggle ${menuOpen ? 'open' : ''}`}
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      <div className={`site-nav-mobile ${menuOpen ? 'open' : ''}`}>
        {showTimer && <CountdownTimer compact label={null} />}
        <button
          onClick={handleWaitlist}
          style={{
            background: '#c038ff',
            color: 'white',
            border: 'none',
            padding: '0.6rem 1.5rem',
            borderRadius: '9999px',
            fontFamily: lexend,
            fontOpticalSizing: 'auto',
            fontSize: '1rem',
            fontWeight: 600,
            cursor: 'pointer',
            boxShadow: '0 4px 14px rgba(0, 200, 255, 0.9)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.5rem',
          }}
        >
          {ctaLabel}
        </button>
      </div>
    </header>
  );
}
